import defaultConfig from "@App/configs/default";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the MyALD whitelabel.
 * Extends the default configuration with specific settings for MyALD.
 */
export const config: Partial<Config> = {
  slug: "myald",
  wording: {
    services: {
      label: {
        useServiceName: false,
        usePremiumServiceNames: true,
      },
    },
  },
  reviews: {
    show: false,
  },
  checkout: {
    ...defaultConfig.checkout,
    optIns: {
      reviewOptIn: {
        show: true,
      },
    },
  },
};

export default config;
